<template>

    <Head :title="__('Password reset')" />
    <div class="min-h-screen w-full bg-splash-bg">
        <div class="flex items-center justify-center min-h-screen"
             style="opacity:1;">
            <div class="flex items-center justify-center min-h-screen">
                <div class="w-full max-w-md border border-gray-100 rounded-md shadow-2xl p-8 mx-4"
                     style="">
                    <div class="flex flex-col items-center mb-6">
                        <Image :src="loginLogo"
                               class="" />
                        <div class="text-2xl font-light text-gray-700">{{ __('Login') }}</div>
                    </div>
                    <v-form name="formForget"
                            class="space-y-6"
                            @keyup.enter="send">
                        <div v-if="success"
                             class="text-center text-green-600 text-base font-semibold mb-2">
                            {{ __('Link was send') }}
                        </div>
                        <div>
                            <label for="email"
                                   class="block text-gray-600 mb-1">{{ __('E-Mail Address') }}</label>
                            <InputText type="text"
                                       id="email"
                                       size="small"
                                       style="width:100%"
                                       :class="{ 'border-indigo-500': !form.errors.email, 'border-red-400': form.errors.email }"
                                       class="rounded px-3 py-2 border focus:outline-none focus:ring-2 focus:ring-indigo-200 w-full"
                                       @input="inputNewData"
                                       v-model="form.email" />
                            <div v-if="form.errors.email"
                                 class="text-red-500 text-sm mt-1">{{ __(form.errors.email) }}</div>
                        </div>
                        <div class="flex flex-col gap-2 mt-4">
                            <Button @click="send"
                                    class="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700 transition w-full"
                                    :label="__('Send Password Reset Link')"
                                    icon="pi pi-sign-in" />
                        </div>
                        <div class="flex items-center justify-center mt-4">
                            <i class="pi pi-star text-indigo-400 mr-2"
                               style="font-size: 1rem;"></i>
                            <Link class="text-indigo-600 hover:underline text-sm"
                                  :href="route('app-login')"
                                  v-if="route().has('app-login')">
                            {{ __('Login') }}
                            </Link>
                        </div>
                    </v-form>
                </div>
            </div>
        </div>
    </div>

    <footer class="w-full flex items-center justify-between bg-gray-50 border-t border-gray-200 py-3 px-6 text-sm fixed bottom-0 left-0 z-10">
        <div class="flex items-center space-x-4">
            <Image :src="developerLogo"
                   class="h-8 w-auto" />
            <div>
                <span class="text-gray-500 font-light">Powered by © 4Evolve wersja 1.0</span>
            </div>
        </div>
    </footer>

</template>

<script setup>
import { ref } from 'vue'
import { useForm } from '@inertiajs/vue3'
import { Head } from '@inertiajs/vue3'
import { Link } from '@inertiajs/vue3'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Layout from '@layouts/LayoutNoMenuNoFooter.vue'
import Image from '@helper/Image.vue'
import { __ } from '@helper/utils.js'
import { loginLogo, developerLogo } from '@helper/constants.js'

defineOptions({ layout: Layout })

const success = ref(false)
const form = useForm({ email: '' })

const inputNewData = () => {
    form.errors.email = null
    success.value = false
}

const send = () => {
    form.post(route('password.email'), {
        onSuccess: () => {
            success.value = true
            form.email = ''
        },
        onError: (errors) => { console.error(errors) }
    })
}
</script>

<style lang="scss" scoped>
.bg-splash-bg {
    position: relative;
    min-height: 100vh;
    width: 100vw;
    background-image: url('/resources/images/logos/start_splash.webp');
    background-size: auto;
    background-position: center;
    background-repeat: no-repeat;
    box-sizing: border-box;
}
</style>
